import type { TheoryLevel } from '../theory-copy/use-theory-copy.js'

/**
 * Which theory cues a chord line shows at a given theory level. One table,
 * so the chip, the cadence tag and the progression tag stay in step.
 *
 * - `outOfKey`: amber name, dotted underline and "(outside the key)" in the
 *   chip's accessible name.
 * - `numeral`, `tension`, `modal`: the chip's Roman superscript, tension stripe
 *   and modal glow. Advanced only; numerals are otherwise in the chord popup.
 * - `cadenceTag`: `'name'` spells the cadence out ("half cadence"),
 *   `'shorthand'` shows the advanced tag ("→ V"), `null` shows nothing.
 * - `progressionTag`: the line-end progression tag when there is no cadence.
 */
export interface ChordCues {
  outOfKey: boolean
  numeral: boolean
  tension: boolean
  modal: boolean
  cadenceTag: 'name' | 'shorthand' | null
  progressionTag: boolean
}

const lightCues: ChordCues = {
  outOfKey: true,
  numeral: false,
  tension: false,
  modal: false,
  cadenceTag: 'name',
  progressionTag: false,
}

const CHORD_CUES: Record<TheoryLevel, ChordCues> = {
  off: { outOfKey: false, numeral: false, tension: false, modal: false, cadenceTag: null, progressionTag: false },
  beginner: lightCues,
  intermediate: lightCues,
  advanced: {
    outOfKey: true,
    numeral: true,
    tension: true,
    modal: true,
    cadenceTag: 'shorthand',
    progressionTag: true,
  },
}

export const getChordCues = (level: TheoryLevel): ChordCues => CHORD_CUES[level]
